import React, { useEffect, useState } from "react";
import {
  DatatablePps,
  SummaryReccomendationComp,
} from "../../components/moleculs";
import axios from "../../library/axios";
import { useParams } from "react-router-dom";
import * as FileSaver from "file-saver";
import { MySwal } from "../../library/swal";
import { LoadingAtom } from "../../components/atoms";
// import * as XLSX from 'xlsx';
import { useLocation } from "react-router-dom";
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { getApiErrorMessage } from '../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../helpers/notifyApiError';

const PpsPage = () => {
  const routeParams = useParams();
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);

  const [search, setSearch] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [itemRekomendasiSurvei, setitemRekomendasiSurvei] = useState([]);
  // const [isLoad, setIsLoad] = useState(false);
  const [loadRecomendations, setLoadRecomendations] = useState(false);
  const [role, setRole] = useState("");

  const fetchRekomendasiSurvei = async () => {
    try {
      setLoadRecomendations(true);
      const options = {
        url: `/pps-item/paramListRekomendasiIdKegiatan/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data.data);
      setitemRekomendasiSurvei(data?.data);
      setFilterData(data?.data);
      setLoadRecomendations(false);
    } catch (err) {
      notifyApiLoadError(err, 'pages/pps/index.fetchRekomendasiSurvei');
      setLoadRecomendations(false);
    }
  };

  const fetchLoginStatus = async () => {
    // console.log(id)
    // return false
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: "info",
          title: "Oops, Unauthorize!",
          text: "Session anda habis, Silahkan login kembali.",
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook("/login");
        }, 3000);
      } else {
        // console.log(data?.data?.mapping_groups[0].module.pathModule)
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname === mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: "info",
            title: "Oops, No Access!",
            text: "Anda tidak memiliki akses di halaman ini.",
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook("/login");
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'pages/pps/index.fetchLoginStatus');
    }
  };

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'pages/pps/index.fetchOneUser');
    }
  };

  useEffect(() => {
    validateAccreditation()
  }, []);

  const validateAccreditation = () => {

    const requestBody = {
      idKegiatanAkreditasi: routeParams.id,
    };

    axios({
      url: "/pps-item/validate",
      method: "POST",
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res.status)
        // return false
        if (res.status === 200) {
          fetchRekomendasiSurvei();
          fetchLoginStatus();
          fetchOneUser();
        } else {
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: res?.data?.message || 'Permintaan tidak berhasil diproses. Silakan coba lagi.',
          });
        }
      })
      .catch((err) => {
        if (err !== "") {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: "error",
            title: "Oops, Error!",
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  // const fileName = 'items-pps';
  // const fileType =
  //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  // const fileExtension = '.xlsx';

  // const exportToCSV = (apiData, fileName) => {
  //   const ws = XLSX.utils.json_to_sheet(apiData);
  //   const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
  //   const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //   const data = new Blob([excelBuffer], { type: fileType });
  //   FileSaver.saveAs(data, fileName + fileExtension);
  // };

  const fileName = "items-pps";
  const fileDokumen = "dokumen-pps";
  const fileJson = ".json";

  const exportItemsPpsToJson = (data) => {
    const jsonBlob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json",
    });
    FileSaver.saveAs(jsonBlob, fileName + fileJson);
  };

  const exportToJson = (data) => {
    const jsonBlob = new Blob([JSON.stringify(data, null, 2)], {
      type: "application/json",
    });
    FileSaver.saveAs(jsonBlob, fileDokumen + fileJson);
  };

  const handleExportItemsPps = async () => {
    // setIsLoad(true);
    try {
      const options = {
        url: `/get-all-pps-item/by-id-kegiatan/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data?.data?.length);
      // return false;
      // const exportData = data.data.map((d) => ({
      //   id: d?.id,
      //   langkahPemenuhan: d?.langkahPemenuhan,
      //   metodePerbaikan: d?.metodePerbaikan,
      //   indikatorPencapaian: d?.indikatorPencapaian,
      //   periodeAwal: d?.periodeAwal,
      //   periodeAkhir: d?.periodeAkhir,
      //   kategoriPeriode: d?.kategoriPeriode,
      //   pic: d?.pic,
      //   keterangan: d?.keterangan,
      //   hasil: d?.hasil,
      //   catatan: d?.catatan,
      //   kategoriPerbaikan: d?.kategoriPerbaikan,
      // }));
      if (data?.data?.length === 0) {
        MySwal.fire({
          icon: "info",
          title: "Request Pending",
          text: "Anda belum membuat Item PPS!",
        });
        return false;
      }
      exportItemsPpsToJson(data?.data, fileName);
      // setIsLoad(false);
    } catch (err) {
      notifyApiLoadError(err, 'pages/pps/index.handleExportItemsPps');
      // setIsLoad(false);
    }
  };

  const handleExportDokumenItemsPps = async () => {
    // console.log(routeParams.id);
    // return false;
    // setIsLoad(true);
    try {
      const options = {
        url: `/get-all-dokumen-pps-item/by-id-kegiatan/${routeParams.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data);
      if (data?.data?.length === 0) {
        MySwal.fire({
          icon: "info",
          title: "Request Pending",
          text: "Anda belum memiliki Dokumen PPS!",
        });
        return false;
      }
      exportToJson(data?.data, fileDokumen);
      // setIsLoad(false);
    } catch (err) {
      notifyApiLoadError(err, 'pages/pps/index.handleExportDokumenItemsPps');
      // setIsLoad(false);
    }
  };

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  useEffect(() => {
    const result = itemRekomendasiSurvei?.filter((item) => {
      let rekomendasiLipa = item?.rekomendasiLipa;
      let faktaAnalisis = item?.faktaAnalisis;
      let Nomor = item?.variables_accreditation?.elements_accreditation?.Nomor;
      let DeskripsiElement =
        item?.variables_accreditation?.elements_accreditation?.Deskripsi;
      let Deskripsi = item?.variables_accreditation?.Deskripsi;

      return rekomendasiLipa
        .concat(faktaAnalisis)
        .concat(Nomor)
        .concat(DeskripsiElement)
        .concat(Deskripsi)
        .toLowerCase()
        .match(search.toString().toLowerCase());
    });
    setFilterData(result);
  }, [search, itemRekomendasiSurvei]);

  return (
    <>
      {loadRecomendations === false ? (
        <>
          {/*begin::Content*/}
          <div
            className="content d-flex flex-column flex-column-fluid"
            id="kt_content"
          >
            {/*begin::Toolbar*/}
            <div className="toolbar" id="kt_toolbar">
              {/*begin::Container*/}
              <div
                id="kt_toolbar_container"
                className="container-fluid d-flex flex-stack"
              >
                {/*begin::Page title*/}
                <div
                  data-kt-swapper="true"
                  data-kt-swapper-mode="prepend"
                  data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
                  className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
                >
                  {/*begin::Title*/}
                  <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                    Perencanaan Perbaikan Strategis (PPS)
                    {/*begin::Separator*/}
                    <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                    {/*end::Separator*/}
                    {/*begin::Description*/}
                    <small className="text-muted fs-7 fw-bold my-1 ms-1">
                      #SPEAK_VERSI_RS
                    </small>
                    {/*end::Description*/}
                  </h1>
                  {/*end::Title*/}
                </div>
                {/*end::Page title*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Toolbar*/}
            {/*begin::Post*/}
            <div className="post d-flex flex-column-fluid" id="kt_post">
              {/*begin::Container*/}
              <div id="kt_content_container" className="container-xxl">
                {/*begin::Row*/}
                <div className="row gy-5 g-xl-8">
                  {/*begin::Col*/}
                  <div className="col-xl-12">
                    <div className="card">
                      <div className="card-body">
                        <SummaryReccomendationComp
                          idKegiatanAkreditasi={routeParams?.id}
                        />
                        <DatatablePps
                          recommendations={filterData}
                          role={role}
                          search={search}
                          handleChangeSearch={handleChangeSearch}
                          handleExportItemsPps={handleExportItemsPps}
                          handleExportDokumenItemsPps={
                            handleExportDokumenItemsPps
                          }
                        />
                      </div>
                    </div>
                  </div>
                  {/*end::Col*/}
                </div>
                {/*end::Row*/}
              </div>
              {/*end::Container*/}
            </div>
            {/*end::Post*/}
          </div>
          {/*end::Content*/}
        </>
      ) : (
        <LoadingAtom />
      )}
    </>
  );
};

export default PpsPage;
